import React from 'react';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import Chip from '@material-ui/core/Chip';

const useStyles = makeStyles((theme) => {
  return {
    chips: {
      display: 'flex',
      flexWrap: 'wrap',
    },
    chip: {
      margin: 2,
    },
    noLabel: {
      marginTop: theme.spacing(3),
    },
  };
});

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

function getStyles(name, selectedData, theme) {
  return {
    fontWeight:
    selectedData.indexOf(name) === -1
      ? theme.typography.fontWeightRegular
      : theme.typography.fontWeightMedium,
  };
}

export default function MultipleSelect(props) {
  const classes = useStyles();
  const theme = useTheme();
  const [selectedData, setData] = React.useState([]);

  const handleChange = (event) => {
    setData(event.target.value);
  };

  React.useEffect(() => {
    if (props.selectedData) setData(props.selectedData);
  }, [props]);

  React.useEffect(() => {
    props.callBack(selectedData);
  });

  return (
    <>
      <InputLabel id="mutiple-chip-label">{props.name}</InputLabel>
      <Select
        labelId="mutiple-chip-label"
        id="mutiple-chip"
        multiple
        value={selectedData}
        onChange={handleChange}
        input={<Input id="select-multiple-chip" />}
        renderValue={(selected) => {
          return (
            <div className={classes.chips}>
              {selected.map((value) => {
                return (
                  props.data && props.data.map((item) => {
                    return (item._id === value ? (<Chip key={value} label={item.name} className={classes.chip} />) : null);
                  })
                );
              })}
            </div>
          );
        }}
        MenuProps={MenuProps}
      >
        {props.data && props.data.map((item) => {
          return (
            <MenuItem key={item._id} value={item._id} style={getStyles(item.name, selectedData, theme)}>
              {item.name}
            </MenuItem>
          );
        })}
      </Select>
    </>
  );
}
